import React from 'react';
import { Table } from 'react-bootstrap';
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';
import { ITransportSummaryCategory } from '../../api/SortsummaryData';

export interface ITransportReportSummary {
  lda: ITransportSummaryCategory;
  sda: ITransportSummaryCategory;
  cold: ITransportSummaryCategory;
  ce: ITransportSummaryCategory;
  crt: ITransportSummaryCategory;
  total: ITransportSummaryCategory
}

export interface ITransportSummaryPreviewProps {
  date: {
    month: number;
    year: number;
  };
  summary: ITransportReportSummary;
  onSend: () => void;
  onCancel: () => void;
}

const TransportSummaryPreview: React.FunctionComponent<ITransportSummaryPreviewProps> = (props: ITransportSummaryPreviewProps) => {
  const renderRow = (name: string, row: ITransportSummaryCategory) => {
    return (
      <tr>
        <th scope="row"><FormattedMessage id={name}/></th>
        <td className="valueCell"><div className="value"><FormattedNumber value={row.km} maximumFractionDigits={2} minimumFractionDigits={2}/></div></td>
        <td><FormattedMessage id="transportsummaryreports.import.resulttable.km"/></td>
        <td className="valueCell"><div className="value"><FormattedNumber value={row.eur} maximumFractionDigits={2} minimumFractionDigits={2}/></div></td>
        <td><FormattedMessage id="transportsummaryreports.import.resulttable.eur"/></td>
        <td className="valueCell"><div className="value"><FormattedNumber value={row.eurPct} maximumFractionDigits={2} minimumFractionDigits={2}/></div></td>
        <td><FormattedMessage id="transportsummaryreports.import.resulttable.eurPct"/></td>
      </tr>
    );
  }

  return (
    <div className="sortReportImportResult generalReportImportResult">
        <div className="d-flex flex-md-row flex-column-reverse">
          <div className="reportResultHeader">
            <h3 className="monthRange">
              <FormattedDate
                  value={new Date(props.date.year, props.date.month)}
                  month="long"
                  year="numeric"
                />
            </h3>
            <h3 className="reportHeader">
              <FormattedMessage id="transportsummaryreports.import.handlingreport"/>
            </h3>
          </div>
          <div className="handlerNameHeader text-right ml-md-auto">
            <h1 className="float-right"><FormattedMessage id="transportsummaryreports.import.header"/></h1>
          </div>
        </div>

        <div className="checkSum borderless table-responsive" >
          <Table className="table table-sm">
            <tbody>
              <tr>
                <th colSpan={7} scope="row" className="sumHeader"><FormattedMessage id="transportsummaryreports.import.resulttable.header"/></th>
              </tr>
              { renderRow('transportsummaryreports.import.resulttable.crt', props.summary.crt) }
              { renderRow('transportsummaryreports.import.resulttable.sda', props.summary.sda) }
              { renderRow('transportsummaryreports.import.resulttable.lda', props.summary.lda) }
              { renderRow('transportsummaryreports.import.resulttable.cool', props.summary.cold) }
              { renderRow('transportsummaryreports.import.resulttable.ce', props.summary.ce) }
              <tr>
                <th scope="row" className="sumHeader"><FormattedMessage id="transportsummaryreports.import.resulttable.total"/></th>
                <td className="valueCell"><div className="value"><FormattedNumber value={props.summary.total.km} maximumFractionDigits={2} minimumFractionDigits={2}/></div></td>
                <td><FormattedMessage id="transportsummaryreports.import.resulttable.km"/></td>
                <td className="valueCell"><div className="value"><FormattedNumber value={props.summary.total.eur} maximumFractionDigits={2} minimumFractionDigits={2}/></div></td>
                <td><FormattedMessage id="transportsummaryreports.import.resulttable.eur"/></td>
                <td className="valueCell"><div className="value"><FormattedNumber value={props.summary.total.eurPct} maximumFractionDigits={2} minimumFractionDigits={2}/></div></td>
                <td><FormattedMessage id="transportsummaryreports.import.resulttable.eurPct"/></td>
              </tr>
            </tbody>
          </Table>
        </div>
        <div className="action-buttons">

          <button className="clear-button  btn btn-secondary"
                  onClick={() => props.onCancel()}>
            <FormattedMessage id="transportsummaryreports.import.reject"/>
          </button>
          <button className="send-button btn btn-primary"
                  onClick={() => props.onSend()}>
            <FormattedMessage id="transportsummaryreports.import.accept"/>
          </button>
        </div>
    </div>
  )
}

export default TransportSummaryPreview;
